const state = {
  feedbackExists: false,
  feedbackDialogVisible: false,
}
const getters = {
  feedbackExists: (state) => state.feedbackExists,
  feedbackDialogVisible: (state) => state.feedbackDialogVisible,
}
const mutations = {
  setFeedbackExists(state, data) {
    state.feedbackExists = data
  },
  setFeedbackDialogVisible(state, data) {
    state.feedbackDialogVisible = data
  },
}
const actions = {
  async checkFeedbackExists({ commit }, payload = { type_id: 8 }) {
    try {
      const data = await this.$api.global.checkFeedbackExists(payload)
      commit('setFeedbackExists', data)
      if (!data) {
        setTimeout(() => {
          commit('setFeedbackDialogVisible', true)
        }, 2000)
      }
    } catch (error) {
      console.error(error)
    }
  },
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
  
